<oe-flat-widget [modalComponent]="modalComponent" style="cursor: pointer;" [title]="'GENERAL.DIGITAL_INPUTS' | translate"
    [icon]="{name: 'radio-button-off-outline', color: 'dark'}">
    <oe-flat-widget-line [name]="'GENERAL.NUMBER_OF_COMPONENTS' | translate" [value]="ioComponentCount">
    </oe-flat-widget-line>
</oe-flat-widget>